import ConsentDefaults from 'constants/consentDefaults'
import CurrentRegionSettings from 'constants/current-region-settings'


export default function makeDefaultTermlyConsents() {
  if ( CurrentRegionSettings.isOptOut() ) {
    return ConsentDefaults.OPT_OUT
  }

  return ConsentDefaults.OPT_IN
}
